"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalLogo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = __importDefault(require("../../../assets/icons"));
var Icon_1 = require("../Icon/Icon");
var PortalLogo_static_1 = require("./PortalLogo.static");
/**
 * PortalLogo atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-portallogo--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/PortalLogo Source}
 */
var PortalLogo = function (_a) {
    var className = _a.className, withoutText = _a.withoutText;
    var path = PortalLogo_static_1.logoWithTextPath;
    var viewBox = PortalLogo_static_1.largeLogoViewbox;
    var width = PortalLogo_static_1.largeLogoWidth;
    if (withoutText) {
        path = icons_1.default.portalLogo.path;
        viewBox = PortalLogo_static_1.smallLogoViewbox;
        width = PortalLogo_static_1.smallLogoWidth;
    }
    return ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: className, color: 'white', iconPath: { path: path, viewBox: viewBox }, size: { height: PortalLogo_static_1.portalLogoHeight, width: width } }));
};
exports.PortalLogo = PortalLogo;
